import type { CompanyItem, CompanyActivation, PaginatedResponse } from "@/lib/api/types"

function sleep(ms: number) {
  return new Promise((r) => setTimeout(r, ms))
}

const data: CompanyItem[] = [
  {
    id: "comp_001",
    name: "Acme Holdings",
    dedup_key: "acme-holdings-001",
    activation: "ACTIVE",
    created_at: "2024-01-15T10:00:00Z",
  },
  {
    id: "comp_002",
    name: "Beta Telecom",
    dedup_key: "beta-telecom-002",
    activation: "ACTIVE",
    created_at: "2024-02-20T14:30:00Z",
  },
  {
    id: "comp_003",
    name: "Gamma Industries",
    dedup_key: "gamma-industries-003",
    activation: "DEACTIVE",
    created_at: "2024-03-10T09:15:00Z",
  },
  {
    id: "comp_004",
    name: "Delta Finance",
    dedup_key: "delta-finance-004",
    activation: "ACTIVE",
    created_at: "2024-04-05T16:45:00Z",
  },
  {
    id: "comp_005",
    name: "Epsilon Tech",
    dedup_key: "epsilon-tech-005",
    activation: "ACTIVE",
    created_at: "2024-05-12T11:20:00Z",
  },
  {
    id: "comp_006",
    name: "Zeta Logistics",
    dedup_key: "zeta-logistics-006",
    activation: "DEACTIVE",
    created_at: "2024-06-18T08:00:00Z",
  },
]

export async function listCompanies(params?: {
  page?: number
  page_size?: number
  q?: string
  activation?: CompanyActivation
}): Promise<PaginatedResponse<CompanyItem>> {
  const page = params?.page ?? 1
  const page_size = params?.page_size ?? 25
  const q = params?.q?.toLowerCase()
  const activation = params?.activation

  await sleep(200)

  let filtered = data

  if (activation) {
    filtered = filtered.filter((c) => c.activation === activation)
  }

  if (q) {
    filtered = filtered.filter(
      (c) =>
        c.name.toLowerCase().includes(q) ||
        c.dedup_key.toLowerCase().includes(q)
    )
  }

  return {
    items: filtered.slice((page - 1) * page_size, page * page_size),
    page,
    page_size,
    total: filtered.length,
  }
}
